import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Modal,
  IconButton,
  Divider,
  Grid,
  InputAdornment,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "../ItemRequest.css";
import SearchIcon from "@mui/icons-material/Search";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { ItemRequestFieldSearchAPI } from "../ItemCreationRequestAction";

const ItemFieldSearchModal = ({
  open = false,
  handleClose = () => {},
  onRowSelect = () => {},
  anyData = "",
  searchProps = () => {},
  xTitle = "Modal",
  vMediaQuery,
}) => {
  const [searchData, setSearchData] = useState("");
  const [searchGridData, setSearchGridData] = useState([]);
  const initialFetch = useRef(true);

  // Columns definition
  const columns = [
    { field: "id", headerName: "ID", hide: true },
    { field: "Code", headerName: "Code", flex: 1.2 },
    { field: "Name", headerName: "Name", flex: 3 },
    { field: "SubCategory", headerName: "SubCategory", hide: true },
    {
      field: "SubCategoryName",
      headerName: "SubCategoryName",
      flex: 2,
      hide: searchProps?.field === "Brand" || searchProps?.field === "Vendor",
    },
    { field: "MainGroupCode", headerName: "MainGroupCode", hide: true },
    {
      field: "MainGroupName",
      headerName: "MainGroupName",
      flex: 2,
      hide: searchProps?.field === "Brand" || searchProps?.field === "Vendor",
    },
  ];

  useEffect(() => {
    setSearchData(anyData);
  }, [anyData]);

  useEffect(() => {
    if (open) {
      if (initialFetch.current && searchData.length > 3) {
        fetchItemData();
        initialFetch.current = false;
      }
    } else {
      initialFetch.current = true;
    }
  }, [open, searchData]);


  const fetchItemData = async () => {
    if (searchData.length <= 3) return;

    const payload = { anyDate: searchData, type: searchProps?.field };
    const response = await ItemRequestFieldSearchAPI(payload);

    if (response.status === 200) {
      let GridID = response?.data?.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setSearchGridData(GridID);
    }
  };

  const fCheckKey = (event) => {
    console.log(event.keyCode === 40, event.key);

    setTimeout(() => {
      if (event.keyCode === 40 && searchGridData.length > 0) {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById("table-main-grid-4");
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            .firstChild?.focus();
        }
      }
    }, 100);
  };

  // const handleClose = () => {
  //   setSearchData('');
  //   setSearchGridData([]);
  //   handleClose();
  // };

  return (
    <div>
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: vMediaQuery ? "95%" : 600,
            backgroundColor: " #ffffff",
            borderRadius: 3,
            boxShadow: 6,
          }}
        >
          <Box className="modal-head">
            <Typography variant="h6" marginLeft={1}>
              {xTitle}
            </Typography>
            <IconButton onClick={handleClose}>
              <CloseIcon sx={{ color: "#ffffff" }} />
            </IconButton>
          </Box>
          <Divider
            sx={{
              "&.MuiDivider-root": {
                borderColor: "#efeaea !important",
              },
            }}
          />

          <Grid
            container
            spacing={3}
            padding={vMediaQuery ? 2 : 3}
            className="ItemRequest-filter"
          >
            <Grid item xs={12}>
              <TextField
                fullWidth
                name="anyData"
                id="anyData"
                autoComplete="off"
                value={searchData}
                onChange={(e) => setSearchData(e.target.value)}
                onKeyDown={(e) => {
                  fCheckKey(e);
                  if (e.key === "Enter" || e._reactName === "onClick") {
                    fetchItemData();
                  }
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end" sx={{ cursor: "pointer" }}>
                      <SearchIcon onClick={fetchItemData} />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          </Grid>
          <div className={vMediaQuery ? "px-3 pb-3" : "px-4 pb-4"}>
            <Box>
              <div
                id="table-main-grid-4"
                style={{ height: "50vh", width: "100%" }}
              >
                <DataGrid
                  rowHeight={30}
                  headerHeight={40}
                  getRowClassName={(params) =>
                    params.indexRelativeToCurrentPage % 2 === 0
                      ? "mui-even-row"
                      : "mui-odd-row"
                  }
                  sx={{
                    border: 1,
                    borderColor: "primary.light",
                  }}
                  height={20}
                  getRowId={(row) => row.id}
                  rows={searchGridData}
                  columns={columns}
                  experimentalFeatures={{ newEditingApi: false }}
                  hideFooter={searchGridData.length < 100}
                  onRowClick={(params) => {
                    onRowSelect(params.row);
                    setTimeout(() => {
                      handleClose();
                    }, 100);
                  }}
                  onCellKeyDown={(params, e) => {
                    if (e.key === 'Enter') {
                      onRowSelect(params.row);
                      handleClose();
                    }
                  }}
                  components={{
                    Toolbar: true ? "" : GridToolbar,
                  }}
                />
              </div>
            </Box>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default ItemFieldSearchModal;
